var Payroll = {}

import IncludeInPayrollErrorModal from 'Employees.mod/Payroll/IncludeInPayrollErrorModal';
Payroll.IncludeInPayrollErrorModal = IncludeInPayrollErrorModal;
export {IncludeInPayrollErrorModal};

export default Payroll;
